import React from 'react';

const SubFieldFilename = () => {
  return (
    <div>
      <h4>Subfield [media_type]</h4>
      <p>
        Image media type (see: <a href="http://www.iana.org/assignments/media-types/image/index.html"
                                 target="_blank">http://www.iana.org/assignments/media-types/image/index.html</a> for a
        list of valid image media types)
      </p>
      <p><strong>MANDATORY</strong></p>
      <div>
        Example:
      </div>
      <pre>
        <code className="language-xml">
          {`<recall lang="en" xmlns="urn:recall-schema">
  <image>
    <filename>Dolphin1.jpg</filename>
    <media_type>image/jpeg</media_type>
    ...
  </image>
  <image>
    <filename>Dolphin2.jpg</filename>
    <media_type>image/jpeg</media_type>
    ...
  </image>
  ...
</recall>
`}
        </code>
      </pre>
    </div>
  );
};

export default SubFieldFilename;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/complex-field-images/subfield-media-type.js